/** ↑↓ の移動先。未フォーカス (-1) からは端の項目へ入り、端では反対の端へ巻き戻る。 */
export function nextMenuItemIndex(current: number, count: number, step: 1 | -1): number {
	if (count === 0) return -1;
	if (current < 0) return step === 1 ? 0 : count - 1;
	return (current + step + count) % count;
}
